import { render, staticRenderFns } from "./activityCourseSubsectionFeedback.html?vue&type=template&id=fcf7956c&scoped=true&external"
import script from "./activityCourseSubsectionFeedback.vue?vue&type=script&lang=js"
export * from "./activityCourseSubsectionFeedback.vue?vue&type=script&lang=js"
import style0 from "./activityCourseSubsectionFeedback.css?vue&type=style&index=0&id=fcf7956c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf7956c",
  null
  
)

export default component.exports